import { render, staticRenderFns } from "./ads-skeleton.vue?vue&type=template&id=3e57c85d&scoped=true"
import script from "./ads-skeleton.vue?vue&type=script&lang=js"
export * from "./ads-skeleton.vue?vue&type=script&lang=js"
import style0 from "./ads-skeleton.vue?vue&type=style&index=0&id=3e57c85d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e57c85d",
  null
  
)

export default component.exports